import { Navigate, Route, Routes } from 'react-router-dom';
import routes from '@/common/routes/routes';
import Seo from './common/components/Seo';

function App() {
	return (
		<>
			<Routes>
				{routes.map((route) => (
					<Route
						key={route.path}
						path={route.path}
						element={
							<>
								<Seo />
								{route.element}
							</>
						}
					/>
				))}
				<Route path='*' element={<Navigate to='/' replace />} />
			</Routes>
		</>
	);
}

export default App;
